import types from "./types";
import service from "./service";

const getImporters = () => {
    return async (dispatch, getState) => {
        let state = getState();
        dispatch({ type: types.GET_IMPORTERS });

        try {
            const result = await service.getNeoImporters(
                state.neoimporter.pagination.actualPage,
                state.neoimporter.filters
            );
            dispatch(getAllSuccess(result.list));
            dispatch(updatePagination(result.pagination));
        } catch (error) {
            // Ideally dispatch an error action here
            console.error("Error fetching importers", error);
        }
    };
};

const changePage = page => {
    return async dispatch => {
        dispatch(changeNeoImporterPage({ page: page }));
        await dispatch(getImporters());
    };
};

const updateFilter = filters => {
    return async dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeNeoImporterPage({ page: 1 }));
        await dispatch(getImporters());
    };
};

const changeFilters = payload => ({
    type: types.FILTER_LIST,
    payload
});

const changeNeoImporterPage = payload => ({
    type: types.CHANGE_PAGE,
    payload
});

const getAllSuccess = payload => ({
    type: types.GET_IMPORTERS_SUCCESS,
    payload
});

const updatePagination = payload => ({
    type: types.UPDATE_PAGINATION,
    payload
});

export default {
    getImporters,
    changePage,
    updateFilter
};
